import { useMemo } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { isValid, format } from 'date-fns';
import useApiFetch from '@/hooks/useApiFetch';
import { getEndpointWithParams } from '@/routes/config';
import Seminars, { SeminarContentType } from '@/services/seminars';
import { chakraExtendedTheme } from '@/styles/theme';
import { FetchApiIds } from '@/types';
import { Paths } from '@/types/routes';
import SeminarsListComponent from './SeminarsList.component';

const SeminarsListPage = function (): JSX.Element {
  const getAllSeminarsResponse = useApiFetch<SeminarContentType[], void>(
    FetchApiIds.ALL_SEMINARS,
    Seminars.getAllSeminars
  );

  const formattedSeminars = useMemo(() => {
    const seminars = getAllSeminarsResponse.data ?? [];
    return seminars.map((seminar) => {
      const createdAtDate = new Date(seminar.createdAt);
      const isDateValid = isValid(createdAtDate);
      const publishedAt = isDateValid ? format(createdAtDate, 'MMM dd p') : '';
      const seminarLink = getEndpointWithParams(Paths.SEMINARS_DETAILS, {
        id: seminar.id,
      });

      return {
        id: seminar.id,
        thumbnail: seminar.thumbnail,
        authorPicture: seminar?.speaker?.picture,
        title: seminar.name,
        authorName: seminar?.speaker?.name,
        link: seminarLink,
        publishedAt,
      };
    });
  }, [getAllSeminarsResponse.data]);

  return (
    <ChakraProvider theme={chakraExtendedTheme}>
      <SeminarsListComponent
        isLoading={getAllSeminarsResponse.isLoading}
        listOfSeminars={formattedSeminars}
      />
    </ChakraProvider>
  );
};

export default SeminarsListPage;
